import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IVorRecord } from "@app/main/components/resourceManagement/vor/vor.interfaces";
import { DateService } from "@app/services/date.service";

@Component({
    selector: 'end-vor-cell',
    template: require("./end-vor-cell.component.html")
})
export class EndVorCellComponent {

    @Input() label: string;
    @Input() vorRecord: IVorRecord;

    @Output() endVor = new EventEmitter<IVorRecord>();

    constructor(private readonly dateService: DateService) { }

    endVorRecord(confirmed: boolean): void {
        if (!confirmed) {
            return;
        }

        this.vorRecord.EndDate = new Date();

        this.endVor.emit(this.vorRecord);
    }
}